import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { InsuranceTableType } from '../ricFormTypes';
import { formatCurrency, getInsurancesTotal } from '../ricFormUtils';
import { SectionItem, SubsectionItem } from '../Components';
import { InsuranceTable as InsuranceTableElement } from '../Components/InsuranceTable';

const SchemaInsuranceTable = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement,
}: {
  formElement: InsuranceTableType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, columns, insuranceTypes, displayTotalValue } =
    formElement;

  const insurances = responseData?.insurances ?? [];

  const HeaderComponent = isSubSectionElement ? SubsectionItem : SectionItem;

  const value = displayTotalValue
    ? formatCurrency(getInsurancesTotal(insurances))
    : null;

  return (
    <>
      <HeaderComponent title={title} subtitle={subtitle} value={value} />
      <InsuranceTableElement
        optionalColumns={columns}
        insuranceTypes={insuranceTypes}
        insurances={insurances}
        onChange={fetchResponseWithUpdatedData}
      />
    </>
  );
};

export default SchemaInsuranceTable;
